import LandingPage from '../components/Landing/LandingPage';
import TermsOfService from '../components/Landing/TermsOfService';
import PrivacyPolicy from '../components/Landing/PrivacyPolicy';
import Disclaimer from '../components/Landing/Disclaimer';
import ResponsibleGambling from '../components/Landing/ResponsibleGambling';
import DashboardLayout from '../components/DashboardLayout/DashboardLayout';
import ResultsTracker from '../components/ResultsTracker/ResultsTracker';
import SnipeHub from '../components/SnipeHub/SnipeHub';
import SnipeHubMatch from '../components/SnipeHub/SnipeHubMatch';
import SnipeFeed from '../components/SnipeFeed/SnipeFeed';
import OddsScreen from '../components/OddsScreen/OddsScreen';
import HotProps from '../components/HotProps/HotProps';
import MultiBuilder from '../components/MultiBuilder/MultiBuilder';
import AFLPropTool from '../components/PropTools/AFL/AFLPropTool';
import PublicCommunityTips from '../components/CommunityTips/PublicCommunityTips';
import Discord from '../components/Discord/Discord';
import ManageSubscriptions from '../components/ManageSubscriptions/ManageSubscriptions';
import AdminTools from '../components/AdminTools/AdminTools';
import ProtectedRoute from '../components/ProtectedRoute';
import RoleGate from '../components/RoleGate';

const routes = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/terms',
    element: <TermsOfService />,
  },
  {
    path: '/privacy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/disclaimer',
    element: <Disclaimer />,
  },
  {
    path: '/responsible-gambling',
    element: <ResponsibleGambling />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'discord',
        element: <Discord />,
      },
      {
        path: 'manage-subscriptions',
        element: <ManageSubscriptions />,
      },
      {
        path: 'snipe-hub',
        element: <SnipeHub />,
      },
      {
        path: 'snipe-hub/match/:matchId',
        element: <SnipeHubMatch />,
      },
      {
        path: 'snipe-feed',
        element: <SnipeFeed />,
      },
      {
        path: 'odds-screen',
        element: <OddsScreen />,
      },
      {
        path: 'hot-props',
        element: <HotProps />,
      },
      {
        path: 'multi-builder',
        element: <MultiBuilder />,
      },
      {
        path: 'prop-tool',
        element: <AFLPropTool />,
      },
      {
        path: 'results-tracker',
        element: <ResultsTracker />,
      },
      {
        // Phased rollout: public community tips are limited to accounts
        // carrying the PUBLIC_TIPS role until the feature goes GA.
        path: 'community-tips',
        element: (
          <RoleGate role="PUBLIC_TIPS">
            <PublicCommunityTips />
          </RoleGate>
        ),
      },
      {
        path: 'admin-tools',
        element: <AdminTools />,
      },
    ],
  },
];

export default routes;

